import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrl: './rating.component.scss'
})
export class RatingComponent {
  @Input() starNumber = 5;
  @Input() rating = 0;
  @Input() innerClass: string;
  @Input() width = 14;
  @Input() height = 14;
  @Input() readOnly = false;
  @Input() showIndexNumber = false;
  @Input() disabled = false;
  @Input() showRateNumber = false;
  @Output() onClick = new EventEmitter<number>()
  constructor() {
  }

  selectRating(index: number) {
      if (!this.readOnly && !this.disabled) {
        this.rating = index + 1;
        this.onClick.emit(this.rating);
      }
  }
  getStarImage(index: number): string {
  if (index < Math.floor(this.rating)) {
    return 'assets/images/star.png';
  } else if (index < this.rating) {
    return 'assets/images/start-half.png';
  } else {
    return 'assets/images/star-empty.png';
  }
}
}

